import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectSiteUrl, selectTermsAndConditionsURL } from 'core/selectors/app';
import { selectUserIsAuthenticated } from 'core/selectors/user';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';
import Modal from 'core/modules/Modal/Modal';
import SectionTitle from 'core/modules/SectionTitle/SectionTitle';
import SignInModal from 'core/modules/Instore2/components/Modals/SignInModal/SignInModal';
import AddNewCardFrame from './components/AddNewCardFrame';
import { useScrollToFaq } from 'core/modules/Instore2/hooks/useScrollToFaq';
import {
  triggerAddNewCardModalIsClosedGaEvent, triggerAddNewCardModalIsViewedGaEvent,
} from 'core/modules/Instore2/actions';
import config from './configs';

import './AddNewCardModal.scss';

function AddNewCardModal({ modal, openModal }) {
  const dispatch = useDispatch();
  const { getTitle } = config;
  const { onFaqClick } = useScrollToFaq();
  const isUserAuthenticated = useSelector(selectUserIsAuthenticated);
  const siteUrl = useSelector(selectSiteUrl);
  const termsAndConditionsURL = useSelector(selectTermsAndConditionsURL);

  const { params = {} } = modal;
  const { merchantName, offerId } = params;

  useEffect(() => {
    dispatch(triggerAddNewCardModalIsViewedGaEvent());
  }, []);

  const onCloseCallback = () => {
    dispatch(triggerAddNewCardModalIsClosedGaEvent());
  };

  if (!isUserAuthenticated) {
    return <SignInModal />;
  }

  const title = getTitle(merchantName);

  return (
    <Modal
      className="mn_instoreModal mn_addNewCardModal"
      options={{ shouldUpdateUrl: true }}
      onCloseCallback={onCloseCallback}
    >
      <SectionTitle id="mn_dialogTitle" title={title} />
      <div className="mn_info" id="mn_dialogDescription">
        We use your linked card to track your qualifying purchases. We'll never charge
        your card. <button className="mn_basicButton" onClick={onFaqClick}>Learn more</button>.
      </div>
      <div className="mn_instoreEnrollCardIframe">
        <AddNewCardFrame offerId={offerId} merchantName={merchantName} openModal={openModal} />
      </div>
      <div className="mn_disclaimer">
        For debit cards, remember to run them as a credit card at checkout (do <strong>not</strong> use your PIN).{' '}
        <br />
        See <a href={`${siteUrl}${termsAndConditionsURL}#instore`}>Terms and Conditions</a> for full card
        and transaction eligibility details.
      </div>
    </Modal>
  );
}

export default (props) => <ComponentErrorBoundary><AddNewCardModal {...props} /></ComponentErrorBoundary>;
